/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "channelURLDefs",
    graphQL: "ChannelURLDef",
    name: "Application Domain Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: 'channelURLDefs',
    defaultOrder: ['address'],
    dynamoPrefix: 'def',
    storageType: 'schema',
    defaultTitle: (data) => {
        return data['address'];
    },
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Application Domain Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        useAsDefault: {
            shortName: "Linking data",
            name: "Use As Default address for linking data",
            type: "boolean",
            defaultValue: true,
        },
        useAsWeb: {
            shortName: "Public web",
            name: "Use this address as link to public web",
            type: "boolean",
            defaultValue: true,
        },
        useApplication: {
            shortName: "Show application",
            name: "Show application on this address",
            type: "boolean",
            defaultValue: true,
        },
        notifyUser: {
            shortName: "Notify user",
            name: "Notify user about app support",
            type: "boolean",
            defaultValue: true,
        },
        isRegexp: {
            name: "Is address REGEXP?",
            type: "boolean",
            description: "Match address as RegExp only. Matching is using only hostname - example ^.*\\\\.example\\\\.com$",
            defaultValue: false,
        },
        address: {
            shortName: "URL",
            name: "URL (including HTTP/HTTPS)",
            type: "string",
            trim: true,
            description: "Protocol is ignored for domain matching. It is used only for linking - so use preferred protocol.",
            defaultValue: ""
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
});
